module.exports = __webpack_public_path__ + "img/user-03.a25e92f0.jpg";